module.exports = __webpack_public_path__ + "static/media/SFST_1-576w.bec24f61.webp";